import React from "react";
import "./BulkModeProgress.css";

const BulkModeProgress = ({ 
  currentBulkIndex, 
  totalContacts, 
  goToPreviousBulkContact, 
  goToNextBulkContact,
  currentBulkContact,
  sentEmails = {},
  canGoToPrevious = () => true,
  bulkContacts = [],
  onDeleteContact = () => {}
}) => {
  // Bestimme, welche Kontakte bereits gesendet wurden
  const getSentStatus = (index) => {
    if (index >= totalContacts || !bulkContacts || index >= bulkContacts.length) return false;
    const contactId = bulkContacts[index];
    return !!sentEmails[contactId];
  };

  // Rendere Paginationspunkte für alle Kontakte
  const renderPaginationDots = () => {
    const dots = [];
    for (let i = 0; i < totalContacts; i++) {
      const isActive = i === currentBulkIndex;
      const isSent = getSentStatus(i);
      
      dots.push(
        <div 
          key={i}
          className={`bulk-pagination-dot ${isActive ? 'active' : ''} ${isSent ? 'sent' : ''}`}
          title={isSent ? 'Bereits gesendet' : isActive ? 'Aktuell' : 'Noch nicht gesendet'}
        />
      );
    }
    return dots;
  };

  // Direkt löschen ohne Bestätigungsabfrage
  const handleDeleteClick = () => {
    if (currentBulkContact) {
      onDeleteContact(currentBulkContact.id);
    }
  };

  return (
    <div className="bulk-mode-progress">
      <div className="bulk-mode-progress-header">
        <h3>
          {currentBulkContact 
            ? `${currentBulkContact.business_name || 'Kontakt'} (${currentBulkIndex + 1} of ${totalContacts})` 
            : `Kontakt ${currentBulkIndex + 1} of ${totalContacts}`}
        </h3>
        <div className="bulk-mode-nav-buttons">
          <button 
            onClick={goToPreviousBulkContact} 
            disabled={!canGoToPrevious()}
            className={`bulk-nav-button ${!canGoToPrevious() ? 'disabled' : ''}`}
            title={!canGoToPrevious() ? 'Bereits gesendete E-Mails können nicht bearbeitet werden' : 'Zum vorherigen Kontakt'}
          >
            ← Back
          </button>
          <button 
            onClick={handleDeleteClick}
            className="bulk-delete-button"
            title="Diesen Kontakt aus der Datenbank löschen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 6h18"></path>
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
            </svg>
          </button>
          <button 
            onClick={goToNextBulkContact} 
            disabled={currentBulkIndex === totalContacts - 1}
            className="bulk-nav-button"
            title={currentBulkIndex === totalContacts - 1 ? 'Letzter Kontakt erreicht' : 'Zum nächsten Kontakt'}
          >
            Next →
          </button>
        </div>
      </div>
      <div className="bulk-progress-bar-container">
        <div 
          className="bulk-progress-bar" 
          style={{ width: `${((currentBulkIndex + 1) / totalContacts) * 100}%` }}
        ></div>
        <div className="bulk-pagination-dots">
          {renderPaginationDots()}
        </div>
      </div>
    </div>
  );
};

export default BulkModeProgress; 